import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import BigPanel from "../components/bigpanel"
import NextReadersLatest from "../components/next-readers-latest"
import NextReadersArchive from "../components/next-readers-archive"
import MovieBlock from "../components/movie-block"
import InformationBlock from "../components/information-block"
import styled from "@emotion/styled"
import HamburgerMenu from "../components/hamburger-menu"
import facepaint from "facepaint"
const breakpoints = [576, 768, 992, 1200]

const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))
const ContentsContainer = styled.div`
  text-align: center;
`

const BottomMovieBlock = styled(MovieBlock)`
  ${mq({
    padding: ["10.0vh 10.0vw 0", "0 10.0vw", "0 70px 180px", "0 70px 180px"],
  })}
`

const IndexPage = () => (
  <Layout>
    <SEO title="NEXT LEADERS 2020　WWDジャパンが選ぶファッション界の未来を担う10組" />
    <HamburgerMenu></HamburgerMenu>
    <BigPanel></BigPanel>
    <ContentsContainer>
      <MovieBlock
        youtubeId={"XKUoD03Rmmc"}
        title={
          <>
            「WWDジャパン」が選ぶ
            <br />
            2020年のネクストリーダーは誰だ！？
          </>
        }
        movieImage={`movie-thum-XKUoD03Rmmc.jpg`}
      ></MovieBlock>
      <NextReadersLatest></NextReadersLatest>
      <BottomMovieBlock
        youtubeId={"JC_xrHbX_M0"}
        title={
          <>
            「WWDジャパン」が考える「ネクストリーダー」を
            <br />
            向編集長が解説
          </>
        }
        movieImage={`movie-thum-JC_xrHbX_M0.jpg`}
      ></BottomMovieBlock>
      <InformationBlock></InformationBlock>

      <NextReadersArchive year={2019}></NextReadersArchive>
      <NextReadersArchive year={2018} noHeader={true}></NextReadersArchive>
    </ContentsContainer>
  </Layout>
)

export default IndexPage
